import styled from 'styled-components';

export const SelectedViewContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 32px;
  /* height: 100%; */
`;

export const InnerDataContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  h4 {
    font-size: 18px;
    font-weight: bold;
    opacity: 0.9;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;

    img {
      width: 18px;
    }
  }

  /* div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  } */

  strong {
    margin-right: 2px;
    font-weight: bold;
    opacity: 1;
    font-size: 15px;
  }

  > small {
        background: ${({ theme }) => theme.colors.blue[50]};
        color: ${({ theme }) => theme.colors.blue[900]};
        font-weight: bold;
        text-transform: uppercase;
        padding: 4px;
        border-radius: 4px;
        font-size: 11px;
        width: 100%;
        text-align: center;
        margin-top: 8px;
  }

  small.green {
          background: ${({ theme }) => theme.colors.green[100]};
          color: ${({ theme }) => theme.colors.green[500]};
  }

  small.orange {
          background: ${({ theme }) => theme.colors.orange[100]};
          color: ${({ theme }) => theme.colors.orange[500]};
    }

  small.gray {
        background: ${({ theme }) => theme.colors.gray[100]};
        color: ${({ theme }) => theme.colors.gray[900]};
  }

  small.red {
        background: ${({ theme }) => theme.colors.danger.light};
        color: ${({ theme }) => theme.colors.danger.dark};
  }

  > div.workplacesContainer {
    max-height: 220px;
    overflow-y: auto;

    > div.workplaceInfoContainer {
      display: flex;
      flex-direction: row;
      align-items: center;

      > small {
          background: ${({ theme }) => theme.colors.blue[50]};
          color: ${({ theme }) => theme.colors.blue[900]};
          font-weight: bold;
          text-transform: uppercase;
          padding: 4px;
          border-radius: 4px;
          font-size: 11px;
          width: 100%;
          text-align: center;
          margin-top: 8px;
    }
    }
  }
`;
